import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

function ExportProgress({ progress }) {
  const { t } = useTranslation();
  if (progress === 0) return <></>;
  return (
    <div className='ExportProgress'>
      <div className='ExportProgress__text'>{t('export')}</div>
      <div id='progressLine'>
        <div id='doneProgress' style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
}

export default ExportProgress;
